import { Menu } from "antd";
import styled from "styled-components";

export const StyledMenuItem = styled(Menu.Item)`
  > span {
    display: flex;
    align-items: center;
  }
`;
